<template>
  <b-col>
    <b-row v-if="Object.keys(item).length > 0">
      <b-col cols="12">
        <div class="information-pro py-2">
          {{ generateTitle }}
        </div>
        <headerPdf title=" اطلاعات فردی" />
      </b-col>
      <b-col cols="12" md="2" class="d-md-none mb-3">
        <b-img-lazy
          thumbnail
          :src="generateImage"
          :onerror="`this.src='${defaultImage}'`"
          width="170"
        />
      </b-col>
      <b-col cols="12" md="10">
        <b-row>
          <b-col cols="12" md="3" v-if="renderedItem.fatherName">
            <eachItemPdf
              :title="$lang.father_name"
              :subTitle="renderedItem.fatherName"
            />
          </b-col>
          <b-col cols="12" md="3" v-if="renderedItem.birthDate">
            <eachItemPdf
              :title="$lang.birth_date"
              :subTitle="renderedItem.birthDate"
            />
          </b-col>
          <b-col cols="12" md="3">
            <eachItemPdf
              :title="`${$lang.birth_certificate} - ${$lang.Place_identity_card}`"
              :subTitle="`${renderedItem.nationalCode} - ${renderedItem.placeIssue}`"
            />
          </b-col>
          <b-col cols="12" md="3" v-if="renderedItem.nationalCode">
            <eachItemPdf
              :title="$lang.national_code"
              :subTitle="renderedItem.nationalCode"
            />
          </b-col>
          <b-col cols="12" md="3" v-if="renderedItem.allegiance">
            <eachItemPdf
              :title="$lang.religion"
              :subTitle="renderedItem.allegiance"
            />
          </b-col>
          <b-col cols="12" md="3" v-if="renderedItem.isMan">
            <eachItemPdf
              :title="$lang.military_service_status"
              :subTitle="renderedItem.military"
            />
          </b-col>
          <b-col cols="12" md="3" v-if="renderedItem.previousLastNam">
            <eachItemPdf
              :title="$lang.previous_lastname"
              :subTitle="renderedItem.previousLastName"
            />
          </b-col>
          <b-col cols="12" md="3" v-if="renderedItem.nickname">
            <eachItemPdf
              :title="$lang.alias"
              :subTitle="renderedItem.nickname"
            />
          </b-col>
          <b-col cols="12" md="3" v-if="renderedItem.birthLocation">
            <eachItemPdf
              :title="$lang.birth_location"
              :subTitle="renderedItem.birthLocation"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="2" class="d-md-block d-none">
        <b-img-lazy
          thumbnail
          :src="generateImage"
          :onerror="`this.src='${defaultImage}'`"
          width="170"
        />
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import headerPdf from "../headerPdf.vue";
import eachItemPdf from "../eachItemPdf.vue";
import { pathOr } from "ramda";
import { generateFullName } from "@/shared/utils";

export default {
  name: "Information",
  components: {
    headerPdf,
    eachItemPdf,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      defaultImage: this.$config.images.shared.noImage,
    };
  },
  computed: {
    generateTitle() {
      const fullName = generateFullName(this.item);
      const marriage = pathOr("", ["marriage"], this.item);
      const mobile = pathOr("", ["mobile"], this.item);
      return [fullName, marriage, mobile].filter(Boolean).join(" - ");
    },
    renderedItem() {
      return {
        previousLastName: pathOr("", ["previous_lastname"], this.item),
        nickname: pathOr("", ["nickname"], this.item),
        fatherName: pathOr("", ["father_name"], this.item),
        birthDate: pathOr("", ["birth_date"], this.item),
        nationalCode: pathOr("", ["national_code"], this.item),
        placeIssue: pathOr("", ["place_issue"], this.item),
        allegiance: pathOr("", ["allegiance"], this.item),
        military: pathOr("", ["military"], this.item),
        birthLocation: pathOr("", ["birth_location"], this.item),
        isMan: pathOr(1, ["gender_id"], this.item) === 1,
      };
    },
    generateImage() {
      const imageData = pathOr([], ["attachments"], this.item);
      const address = pathOr(
        "",
        ["address"],
        imageData.find((row) => row.type === "thumb")
      );
      return address;
    },
  },
  methods: {
    pathOr,
  },
};
</script>

<style lang="scss" scoped>
.information-pro {
  font-size: 14px;
  font-weight: 500;
  color: #282c52;
}
</style>
